module.exports = ".header {\n  position: relative;\n  z-index: 3;\n}\n"